var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListbullets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45 6a.8.8 0 01.8-.8h12a.8.8 0 010 1.6h-12a.8.8 0 01-.8-.8zM7.45 12a.8.8 0 01.8-.8h12a.8.8 0 010 1.6h-12a.8.8 0 01-.8-.8zM7.45 18a.8.8 0 01.8-.8h12a.8.8 0 010 1.6h-12a.8.8 0 01-.8-.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM4.125 13.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM4.125 19.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
  }))));
}

export default SvgListbullets;